module.exports = __webpack_public_path__ + "static/img/xsdc3.331b94e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xsdc3.png
// module id = gxOw
// module chunks = 1